//import '@ui-m/Widget-yopt/components/RateContent/index.scss'

import { Button, Carousel } from 'antd'
import { useRef } from 'react'

//
import Icon from '@ui-pc/Icon'
import Switch from '@ui-pc/Switch'
import { createdPortal, isMobileProject } from '@utils/index'
import { Knife, Type } from '@utils/tool'

import { ctx } from '../../../utils'
import { VideoBox } from './VideoBox'

/**
 *
 */
export const ReviewPhotos = () => {
  const [state] = ctx.useState()

  const ref = ctx.useRef()

  const refs = useRef<any>({})

  const { reviewCard, reviewPhotos } = state

  const ViewPhotosDetail = ref.main.ViewPhotosDetail

  return (
    <Switch either={!Type.isEmpty(reviewPhotos)}>
      <div className="review-photos">
        <span className="title">Review Photos</span>
        <ViewPhotosDetail refs={refs} list={reviewCard} photos={reviewPhotos} />
        <Carousel
          {...{
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 5.5,
            slidesToScroll: 5,
            arrows: true,
            className: 'widget-review-slider',
            ...(isMobileProject
              ? { arrows: false, slidesToShow: 4.2, slidesToScroll: 4 }
              : {}),
            nextArrow: (
              <Button
                aria-label="@hernest.com"
                className="slider-button slider-next"
                icon={<Icon customSrc="icon-m_ic_jiantou" />}
              />
            ),
            prevArrow: (
              <Button
                aria-label="@hernest.com"
                className="slider-button slider-pre"
                icon={
                  <Icon
                    customSrc="icon-m_ic_jiantou"
                    style={{ transform: 'rotateY(180deg)' }}
                  />
                }
              />
            )
          }}>
          {reviewPhotos?.map((data, index) => {
            return (
              <div
                onClick={() => {
                  refs.current.useShow(index, data.reviewId)
                }}>
                <Switch either={data.type === 2}>
                  <VideoBox readonly>
                    <video
                      loop
                      muted
                      autoPlay={false}
                      src={data.src}
                      controls={false}
                    />
                  </VideoBox>
                  <Icon className="img-video" src={data.src} alt="" />
                </Switch>
              </div>
            )
          })}
        </Carousel>
      </div>
    </Switch>
  )
}
